let cachedTenantCode = null;
let tenantResolutionPromise = null;
let tenantResolved = false;

function getHostInfo() {
  if (typeof window === 'undefined') {
    return { cleanHost: '', firstLabel: '' };
  }
  const cleanHost = (window.location.hostname || '').toLowerCase();
  const firstLabel = cleanHost.split('.')[0] || '';
  return { cleanHost, firstLabel };
}

export function getTenantCode() {
  if (typeof window === 'undefined') return null;
  const params = new URLSearchParams(window.location.search);
  const code = params.get('cod');
  if (code && code.trim()) {
    cachedTenantCode = code.trim();
    tenantResolved = true;
    return cachedTenantCode;
  }
  
  // Se abbiamo un codice in cache, usalo
  if (cachedTenantCode) {
    return cachedTenantCode;
  }
  
  return null;
}

/**
 * Controlla se il tenant deve essere risolto dall'host (dominio personalizzato)
 */
export function needsHostResolution() {
  if (typeof window === 'undefined') return false;
  const params = new URLSearchParams(window.location.search);
  const code = params.get('cod');
  if (code && code.trim()) return false; // Già presente nell'URL
  if (cachedTenantCode) return false; // Già in cache
  
  const { cleanHost, firstLabel } = getHostInfo();
  if (!cleanHost) return false;
  if (cleanHost === 'localhost' || cleanHost === '127.0.0.1' || cleanHost === '::1') return false;
  if (cleanHost.includes('azurewebsites.net')) return false;
  if (firstLabel === 'www' || firstLabel === 'api') return false;
  return true;
}

/**
 * Risolve il tenant dall'host. Restituisce una Promise che si risolve quando
 * la risoluzione è completata (con successo o errore).
 */
export function resolveTenantFromHost() {
  if (tenantResolved) {
    return Promise.resolve({
      code: cachedTenantCode,
      unavailable: false,
      status: 200,
      detail: null,
    });
  }
  
  if (tenantResolutionPromise) {
    return tenantResolutionPromise;
  }
  
  if (!needsHostResolution()) {
    tenantResolved = true;
    return Promise.resolve({
      code: null,
      unavailable: false,
      status: 200,
      detail: null,
    });
  }
  
  tenantResolutionPromise = fetch('/api/admin/tenants/resolve')
    .then(async (res) => {
      if (res.ok) {
        const data = await res.json();
        return { ok: true, status: res.status, data, detail: null };
      }
      const problem = await res.json().catch(() => ({}));
      return {
        ok: false,
        status: res.status,
        data: null,
        detail: problem?.detail || problem?.title || null,
      };
    })
    .then(result => {
      tenantResolved = true;
      const data = result?.data;
      if (data && data.code) {
        cachedTenantCode = data.code;
        // Aggiungi il cod all'URL se non c'è già
        const newUrl = new URL(window.location.href);
        if (!newUrl.searchParams.has('cod')) {
          newUrl.searchParams.set('cod', data.code);
          window.history.replaceState({}, '', newUrl.toString());
          // Forza un reload per applicare il cambio
          window.location.reload();
        }
        return {
          code: data.code,
          unavailable: false,
          status: result?.status || 200,
          detail: null,
        };
      }
      return {
        code: null,
        unavailable: result?.status === 403 || result?.status === 404 || result?.status === 503,
        status: result?.status || 500,
        detail: result?.detail || null,
      };
    })
    .catch(() => {
      tenantResolved = true;
      return {
        code: null,
        unavailable: true,
        status: 500,
        detail: null,
      };
    });
  
  return tenantResolutionPromise;
}

/**
 * Indica se la risoluzione del tenant è completata
 */
export function isTenantResolved() {
  return tenantResolved;
}

export function withTenant(url, overrideCode) {
  const code = overrideCode || getTenantCode();
  if (!code) return url;
  const resolved = new URL(url, window.location.origin);
  if (!resolved.searchParams.has('cod')) {
    resolved.searchParams.set('cod', code);
  }
  return resolved.pathname + resolved.search + resolved.hash;
}
